// Import scripts
// Styles
import '../sass/main.scss';
import AOS from 'aos';

// Import asset images
// import './images';

// Import javascript
// import debounce from './helpers/debounce';
import activeTrigger from './components/utilities/activeTrigger';
import customSelect from './components/customSelect';
import siteNav from './components/siteNav';
import filters from './components/filters';
import pathways from './components/pathways';
import alerts from './components/alerts';
import loadMore from './components/loadMore';
import swiper from './components/swiper';
import videos from './components/videos';
import accordion from './components/accordion';
import limitInputs from './components/limitInputs';

jQuery(document).ready(function () {
  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  customSelect(jQuery);
  activeTrigger();
  siteNav(jQuery);
  filters(jQuery);
  pathways(jQuery);
  alerts(jQuery);
  loadMore(jQuery);
  swiper();
  videos();
  accordion(jQuery);
  limitInputs(jQuery);

  AOS.init();
});